function i(l) {
  return l == null || l === void 0;
}
export {
  i as isNill
};
